import { Suggestion, SuggestionOutput } from "@imi-ernd-be/hyselect-engine";
import { assert, isEmpty } from "radashi";
import { withDelete } from "../../helpers/withDelete";
import { buildProduct } from "../../products/buildProduct";
import { buildSubProducts } from "../../products/buildSubProducts";
import { isPhysicalType } from "../../units/constants";
import {
  buildValidationResult,
  isErrorSeverity,
} from "../../validationResults/buildValidationResult";
import { toArray } from "../../vector";

export type SuggestionDetails = ReturnType<typeof buildSuggestion>;

export function buildSuggestion(suggestion: Suggestion | null) {
  assert(suggestion, "Suggestion must not be null");
  const productDetails = suggestion.getProductDetail();

  return {
    ...buildProduct(productDetails, {
      id: suggestion.delimitedID,
      productSetId: "",
      type: "product",
    }),
    delimitedId: suggestion.delimitedID,
    isBestChoice: suggestion.isBestChoice,
    output: toArray(suggestion.getSuggestionOutputList()).map(
      buildSuggestionOutput,
    ),
    priority: suggestion.isLowPriority ? 0 : 1,
    status: buildSuggestionStatus(suggestion),
    subProducts: buildSubProducts(suggestion.subProducts),
  };
}

export function buildSuggestionOutput(item: SuggestionOutput) {
  const validationResult = item.getValidationResult();
  return withDelete(item, {
    id: item.translationKey.split(".").pop() ?? "",
    physicalType: isPhysicalType(item.physicalType) ? item.physicalType : null,
    translationKey: item.translationKey,
    validationResult: buildValidationResult(validationResult),
    value: item.isNotNumber ? item.valueString : item.value,
  });
}

function buildSuggestionStatus(suggestion: Suggestion) {
  const message = suggestion.status.message;
  const severity = suggestion.status.severity;

  return {
    message: isEmpty(message) ? null : message,
    reference: suggestion.status.reference,
    severity: isErrorSeverity(severity) ? severity : "info",
    translationKey: suggestion.status.translationKey,
  };
}
